










import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class PrimaryButton extends Vue {
  public static CSS = {
    'clr-wht': true,
    'hvr-bg-red': true,
    'hvr-clr-red': true,
    'rounded-xl': true,
    'btn-neumo': true,
    'btn-neumo-co': true,
    bsd: true,
    'bc-wht': true,
    'bw-02rbtn-primary': true,
    'btn-sm': true,
    'px-2': true,
  };

  @Prop()
  title!: string;

  @Prop({ default: false })
  centering!: boolean;

  @Prop()
  css_class!: any;

  @Prop({ default: '' })
  type!: string;
}
